
import Injection = EECore.Injection;

@Injection.injectableClass("DocumentCentreAdvancedSearchBarBehavior")
export default class AdvancedSearchBarBehavior {

  disableSearch(component: Element) {
    const inputField = component.querySelector("input");
    if (inputField != null) {
      inputField.setAttribute("disabled", "true");
      inputField.style.cursor = "no-drop";
    }
    
    const button = component.querySelector("button");
    if (button != null) {
      button.setAttribute("disabled", "true");
      button.style.cursor = "no-drop";
      button.style.background = "#ebebe4";
    }
  }
}
